/**
 * Created by fers on 27.07.16.
 */
import {detect} from 'detect-browser';
import EventTracker from '../app/EventTracker';
import { v4 as uuidv4 } from 'uuid';
import {safeJSONparse} from "../../common/util/safeJSONparse";
import config from '../../common/config';

const browser = detect();
const CHROME_EXTENSION_ID = 'jfhhlomiaamfbmgkglpdahanoddplkmm';

const extensionIds = [
    CHROME_EXTENSION_ID,  /* published extension in chrome web store */
    'fndijjmbniflkfkcfcmjgjfjbikoaafk',  /* privately packaged extension */
    'lcmcfbnohanimjelbemcdjdnkbaikpil',
	'cahigmfihbgbbkmkecglmnnjhoendijb',
	'fdjaaejkflcgjilcppfkiibpnhpknbfg',
    'doddjigaeokmgmcfjnfpkpkpfiogdgef',
];

export function checkLastError() {
	let lastError = window.chrome.runtime.lastError;
	if (lastError) {
		if (lastError.message && lastError.message === "Could not establish connection. Receiving end does not exist.") {
			//nothing
		}
		else {
			// eslint-disable-next-line no-console
			console.error(lastError.message);
		}
	}
}

export function sendToExtensionById(extensionId, msg, receiveResponse) {
    if (window.chrome && window.chrome.runtime && window.chrome.runtime.sendMessage) {
        let timeout = setTimeout(() => {
            receiveResponse(null);
        }, 5000);

        window.chrome.runtime.sendMessage(extensionId, msg, (response) => {
			checkLastError();

            clearTimeout(timeout);
            receiveResponse(response);
        });
    } else {

        /* support for firefox */
        if (receiveResponse) {
            let timeout;

            let fce = function (event) {
                if (event.data && event.data.isResponse) {
                    receiveResponse(event.data);
                    window.removeEventListener("message", fce);
                    clearTimeout(timeout);
                }

            };

            window.addEventListener("message", fce); // nosemgrep

            timeout = setTimeout(() => {
                receiveResponse(null);
                window.removeEventListener("message", fce);
            }, 2000);
        }

       // window.postMessage(msg, "*");
    }
}

export const extensionDefinitions = {
    'chrome': {
        niceName: 'Google Chrome',
        url: 'https://chrome.google.com/webstore/detail/' + CHROME_EXTENSION_ID,
    },
    'firefox': {
        niceName: 'Mozilla Firefox',
//        url: 'https://addons.mozilla.org/cs/firefox/addon/dativery/',
        url: 'https://cdn.dativery.com/cdn/extension/dativery-' + config.EXTENSION_VERSION + '-an%2Bfx.xpi'
    },
    'safari': {
        niceName: 'Apple Safari',
        url: 'https://cdn.dativery.com/cdn/extension/Dativery-' + config.EXTENSION_VERSION + '.safariextz',
    },
};

function sendToExtensionOld(msg) {
    if (window.chrome && window.chrome.runtime && window.chrome.runtime.sendMessage) {

        return Promise.all(extensionIds.map((extensionId) => {
			return new Promise((resolve, reject) => {
				sendToExtensionById(extensionId, msg, (response) => {
					resolve(response);
				});
			});

        })).then((responses) => {
            responses = responses.filter((response) => response);

            return (responses.length > 0 ? responses[0] : null);
        });
    }

	return new Promise((resolve, reject) => {
		sendToExtensionById("*", msg, (response) => {
			resolve(response);
		});
	});
}

function sendToExtensionNew(msg) {
	return new Promise((resolve, reject) => {
		let messageUuid = uuidv4();
		let ev = new CustomEvent('dativery-message', {
			detail: {
				...msg,
				uuid: messageUuid
			}
		});

		let responseCatcher = (event) => {
			// detail is passed as JSON as firefox pass only object reference -> object was created in different context -> cannot read it's properties
			let eventDetail = safeJSONparse(event.detail);

			// it is indeed reponse to this request
			if (eventDetail && eventDetail.request && eventDetail.request.uuid === messageUuid) {
				document.removeEventListener("dativery-message-response", responseCatcher);
				resolve(eventDetail.wrappedContent);
			}
		};

		document.addEventListener("dativery-message-response", responseCatcher);
		document.dispatchEvent(ev);
	});
}

let cacheUseNewSendToExtensionResult;
function useNewSendToExtension() {
	return new Promise((resolve, reject) => {
		if (cacheUseNewSendToExtensionResult !== undefined) {
			resolve(Boolean(cacheUseNewSendToExtensionResult));
			return;
		}

		let timeout = setTimeout(() => {
			resolve(false);
		}, 100);

		let listener = e => {
			clearTimeout(timeout);
			document.removeEventListener("dativery-message-response", listener);
			resolve(true);
		};
		document.addEventListener("dativery-content-test-success", listener, false);

		let event = new CustomEvent('dativery-content-test', {});
		document.dispatchEvent(event);
	});
}

export function sendToExtension(msg) {
    return useNewSendToExtension().then(useNew => {
        let sendToExtensionFce = sendToExtensionOld;

        if (useNew) {
            sendToExtensionFce = sendToExtensionNew;
        }

        return sendToExtensionFce(msg);
	});
}

export function isBrowserSupported() {
    if (!browser) {
        return false;
    }
    let def = extensionDefinitions[browser.name];

    if (def) {
        return true;
    } else {
        return false;
    }
}

let extensionPresent : boolean = true;

export function isExtensionPresent() : boolean {
    return extensionPresent;
}

export function setExtensionPresent(isPresent : boolean) {
    extensionPresent = isPresent;
}

export function getExtensionURL() {
    let def = null;

    if (browser) {
        def = extensionDefinitions[browser.name];
    }

    if (def) {
        return def.url;
    } else {
        return "https://www.dativery.com/support/unsupported-browser/";
    }
}

// chrome store disabled inline installation, see https://developer.chrome.com/extensions/inline_faq
export function onClickExtensionInstall(newTab = false) : Promise {
    EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
        event: 'extension-install',
        type: 'application'
    });

	if (newTab) {
		window.open(getExtensionURL(), '_blank');
	}
	else {
		window.location = getExtensionURL();
	}
    return Promise.resolve(false);
}

export function isExtensionIframe() {
	let origin = window.location.origin;

	return isExtensionUrl(origin);
}

export function isExtensionUrl(url) {
    if (!url) {
        return false;
    }
	return url.startsWith('chrome-extension://') || url.startsWith('safari-extension://') || url.startsWith('moz-extension://');
}
